export default __webpack_public_path__ + "static/media/area-29.75dd63a3.jpg";